<template>
  <div
    id="npsModal"
    class="modal fade"
    role="dialog"
    aria-labelledby="myModalLabel"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 id="myModalLabel" class="modal-title">
            {{ $t('nps_survey.title') }}
          </h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="container">
                <div>{{ $t('nps_survey.question1') }}? *</div>
                <div class="widget">
                  <button data="detractor" @click="handleSelect">
                    0
                  </button>
                  <button data="detractor" @click="handleSelect">
                    1
                  </button>
                  <button data="detractor" @click="handleSelect">
                    2
                  </button>
                  <button data="detractor" @click="handleSelect">
                    3
                  </button>
                  <button data="detractor" @click="handleSelect">
                    4
                  </button>
                  <button data="detractor" @click="handleSelect">
                    5
                  </button>
                  <button data="detractor" @click="handleSelect">6</button>
                  <button data="passive" @click="handleSelect">7</button>
                  <button data="passive" @click="handleSelect">8</button>
                  <button data="promoter" @click="handleSelect">
                    9
                  </button>
                  <button data="promoter" @click="handleSelect">
                    10
                  </button>
                  <div class="col-md-12">
                    <div v-if="showValidation" class="row">
                      <span style="color: #d84d51">{{
                        $t('nps_survey.validation')
                      }}</span>
                    </div>
                  </div>
                </div>
                <div v-if="Nota">
                  <div>{{ $t('nps_survey.question2') }}:</div>
                  <textarea
                    v-model="Mensagem"
                    height="150"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-nps">
          <div>
            <button type="button" class="btn btn-white" @click="submit(false)">
              {{ $t('nps_survey.deny') }}
            </button>
          </div>
          <button type="button" class="btn btn-white" data-dismiss="modal">
            {{ $t('nps_survey.close') }}
          </button>
          <button type="button" class="btn btn-primary" @click="submit">
            {{ $t('save') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import store from '../store'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'NpsSurveyModal',
  async beforeCreate() {
    await store.dispatch('npsSurvey/fetchNPS')
  },
  created() {
    setTimeout(() => {
      this.handleShow()
    }, 3000)
  },
  methods: {
    handleShow() {
      if (!this.showedOnce && this.showNps) {
        $('#npsModal').modal()
        this.showedOnce = true
      }
    },
    handleSelect(event) {
      this.Nota = event.srcElement.innerText
      var el = $(event.srcElement)
      var prevAll = $(event.srcElement).prevAll()
      var nextAll = $(event.srcElement).nextAll()

      var className = el.attr('data') + '-hover'

      el.addClass(className)
      prevAll.removeClass('detractor-hover passive-hover promoter-hover')
      nextAll.removeClass('detractor-hover passive-hover promoter-hover')
    },
    async submit(answer) {
      if (!answer) {
        await this.submitNPS({ CampanhaRespondida: false })
        $('#npsModal').modal('hide')
        return
      }
      if (this.Nota === undefined) {
        this.validate = true
        return
      }
      await this.submitNPS({
        Nota: this.Nota,
        Mensagem: this.Mensagem
      })
      $('#npsModal').modal('hide')
    },
    ...mapActions('npsSurvey', ['submitNPS'])
  },
  computed: {
    showValidation() {
      return !this.Nota && this.validate
    },
    ...mapGetters('npsSurvey', ['showNps'])
  },
  data() {
    return {
      showedOnce: false,
      Nota: undefined,
      Mensagem: '',
      validate: false
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-nps {
  padding: 15px;
  border-top: 1px solid #e5e5e5;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;

  :first-child {
    flex-grow: 5;
  }
}
.container {
  margin: 40px auto;
  width: 80%;

  .widget {
    padding: 15px 1px;

    span {
      color: #aaa;
      font-size: 12px;
    }

    button {
      /* padding: 5px 10px; */
      font-size: 16px;
      white-space: nowrap;
      vertical-align: middle;
      display: inline-block;
      background: none;
      border: none;
      box-shadow: none;
      cursor: pointer;
      text-align: center;
      font-weight: 500;
      border-radius: 100%;
      margin: 0;
      outline: none;
      margin-left: 0.5px;
      width: 40px;
      height: 40px;
      border: 3px solid #eee;
      transform: scale(1);

      transition: background 0.2s ease-in, color 0.2s ease-in,
        border-color 0.2s ease-in,
        transform 0.2s cubic-bezier(0.5, 2, 0.5, 0.75);

      &.detractor-hover {
        background: #f44336;
        color: white;
        border-color: lighten(#f44336, 5%);
        transform: scale(1.05);
      }

      &.passive-hover {
        background: #f57c00;
        color: white;
        border-color: lighten(#f57c00, 5%);
        transform: scale(1.05);
      }

      &.promoter-hover {
        background: #4caf50;
        color: white;
        border-color: lighten(#4caf50, 5%);
        transform: scale(1.05);
      }
    }

    &.widget-sm {
      width: 315px;
      background: #eee;
      border: 2px solid #ccc;
      padding: 15px;
      box-sizing: border-box;
      position: relative;
      padding-bottom: 30px;

      .positive-text,
      .negative-text {
        position: absolute;
      }

      .positive-text {
        right: 20px;
        bottom: 10px;
        text-align: right;
      }

      .negative-text {
        left: 20px;
        bottom: 10px;
        text-align: left;
      }

      button {
        border: none;
        margin-left: -3px;
        width: 27px;
        height: 27px;
        font-size: 12px;
        font-weight: normal;
        transform: scale(1) !important;
        /* background-color: #ccc; */
        border-radius: none;
        text-align: center;
        display: inline-block;
      }
    }
  }
}
</style>
